import validator from 'validator';
import { SequenceStepExecutionDay } from '../../../enums/sequence-step';

export const validateRelativeDays = (
  value: string,
  minRelativeDays: number,
): string => {
  if (
    !validator.isLength(value, { min: 1, max: 3 }) ||
    !validator.isInt(value, {
      min: minRelativeDays,
      max: SequenceStepExecutionDay.MaxDay,
    }) ||
    !validator.isNumeric(value)
  ) {
    return `Day must be between ${minRelativeDays} to ${SequenceStepExecutionDay.MaxDay}`;
  }
  return '';
};
